import React, { useState } from "react";
import styles from "./styles.module.css";
import Modal from "../modal";
import { MdClose } from "react-icons/md";
import { makeid } from "../utils/pageactions";
import ElementActions from "./elementactions";

const getDefaultProps = (props) => {
  const _props = {};
  props.forEach((p) => {
    _props[p.name] = p.editorPrams
      ? p.editorPrams.default
        ? p.editorPrams.default
        : null
      : null;
  });
  return _props;
};

export default function SelectAction({
  open,
  onSelect,
  onClose,
  actions,
  types,
}) {
  const [type, setType] = useState(false);

  const handleSelect = (a) => {
    if (a.children) {
      const children = a.children.map((child) => {
        return {
          name: child.name,
          displayName: child.displayName,
          id: makeid(16),
          actions: [],
          props: {},
        };
      });
      return onSelect({
        name: a.displayName,
        id: makeid(16),
        children: children,
      });
    }
    onSelect({
      name: a.displayName,
      action: a.name,
      id: makeid(16),
      props: getDefaultProps(a.props),
      async: a.async ? a.async : null,
      return: a.return || null,
    });
  };
  return (
    <Modal onClose={onClose} open={open}>
      <div className={styles.selectAction}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <div className={styles.title}>Add Action</div>
          <MdClose onClick={onClose} className={styles.close} />
        </div>
        <div style={{ display: "flex" }}>
          <div className={styles.types}>
            {types.map((t) => {
              return (
                <div
                  onMouseEnter={() => setType(t)}
                  className={styles.typeItem}
                  key={t}
                >
                  {t}
                </div>
              );
            })}
          </div>
          {type === "Page" ? (
            <ElementActions
              actions={actions.filter((x) => x.type === type)}
              onSelect={handleSelect}
            />
          ) : (
            <div className={styles.actions}>
              {actions
                .filter((x) => x.type === type)
                .map((a) => {
                  return (
                    <div
                      onClick={() => handleSelect(a)}
                      className={styles.actionItem}
                      key={a.name}
                    >
                      {a.displayName}
                    </div>
                  );
                })}
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
}
